export default {
  // 新手引導
  finishButton: "完成",

  // 輸入框和搜索
  addressPlaceholder: "請輸入地址或者調證用戶ID",
  queryButton: "查詢",

  // 標籤管理
  labelManagement: "標籤管理",
  addLabel: "添加標籤",

  // 空狀態
  emptyMessage: "請輸入地址或調證用戶ID以查詢對應標籤",
  loading: "拼命加載中",

  // 標籤信息
  recentOperator: "最近操作人",
  modifyButton: "修改",
  balance: "餘額",

  // 刪除確認
  deleteConfirmTitle: "刪除確認",
  deleteConfirmMessage: "是否要刪除此條標籤？",
  no: "否",
  yes: "是",
  deleteSuccess: "刪除成功",
  deleteCanceled: "已取消刪除",

  // 標籤對話框
  addLabelTitle: "添加標籤",
  modifyLabelTitle: "修改標籤",
  labelSelect: "標籤",
  pleaseSelect: "請選擇",
  pleaseInput: "請輸入內容",
  cancel: "取 消",
  confirm: "確 定",
  addNew: "新增",

  // 驗證消息
  requiredFieldError: "*號為必填項",
  pleaseEnterAddress: "請輸入地址或者調證用戶ID",

  // 審核相關
  reviewTitle: "標籤審核提示",
  reviewMessage:
    "當前添加的地址標籤包含關鍵屬性，需等待管理員審核通過後方可生效。",
  submitSuccessWithReview:
    "提交成功，管理員審核通過後方可在{productName}中查看",
  addLabelSuccess: "此數據已成功打上該標籤",
  modifyLabelSuccess: "修改標籤成功",

  // 刪除操作
  deleteConfirm: "確認刪除當前標籤？",

  // 複製功能
  copySuccess: "複製成功",

  // 表單驗證提示
  pleaseSelectOption: "請選擇",
  pleaseInputField: "請輸入{field}",

  // tagdetialfn.js 相關字符串
  // 刪除確認
  deleteConfirmMessage: "此操作將永久刪除該標籤, 是否繼續?",
  deleteConfirmTitle: "刪除確認",

  // 按鈕文本
  confirm: "確定",
  cancel: "取消",

  // 成功消息
  addLabelSuccess: "此節點已成功打上該標籤",
  deleteLabelSuccess: "刪除標籤成功",
  deleteCanceled: "已取消刪除",

  // 平台地址
  platformAddress: "平台地址",
};
